import { GridItem, Text, VStack } from "@chakra-ui/react";
import { formatStringWithCommas } from "@syla/shared/helpers/formatting";
import {
  PlanStatus,
  getSubscriptionState,
} from "@syla/shared/types/helpers/subscriptions";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import React, { Fragment } from "react";

interface TransactionCapProps {
  subscription?: SubscriptionWithPlansAndAccess<string>;
}

export const TransactionCap = ({ subscription }: TransactionCapProps) => {
  if (!subscription) {
    return null;
  }

  const transactionLimit = subscription.plan.features.transactionLimit;

  const subscriptionStatus = subscription && getSubscriptionState(subscription);

  if (subscriptionStatus.planStatus === PlanStatus.Expired) {
    return null;
  }

  const value = formatStringWithCommas(transactionLimit.toString());

  return (
    <>
      <GridItem>
        <VStack alignItems="flex-start">
          <Text fontWeight="bold">Transaction Cap</Text>
          <Text>The maximum number of transactions supported on your plan</Text>
        </VStack>
      </GridItem>

      <GridItem>
        <Text>{value}</Text>
      </GridItem>
    </>
  );
};
